module.exports = __webpack_public_path__ + "static/media/nft-music-icon1.e52828f5.svg";